import { Box, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

/**
 * Standard page scaffolding: an uppercase breadcrumb line, the page title, an optional subtitle, and
 * a right-aligned actions slot (keep to one primary button per view). Used on every screen so the app
 * reads as one product.
 */
export function PageHeader({
  title, breadcrumbs, subtitle, actions,
}: {
  title: string;
  breadcrumbs?: string[];
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Typography
          variant="caption"
          sx={{ color: "text.secondary", letterSpacing: "0.06em", textTransform: "uppercase", fontWeight: 600 }}
        >
          {breadcrumbs.join("  /  ")}
        </Typography>
      )}
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
        sx={{ mt: breadcrumbs?.length ? 0.5 : 0 }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h5">{title}</Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>{actions}</Stack>}
      </Stack>
    </Box>
  );
}
